/**
 * Last N on-ground sales for the new-customer form: stored client-side only.
 * Each successful sale appends a row; used for the history modal and
 * "open in Pass activation" without hitting list endpoints.
 */

const STORAGE_KEY = "nacelle:recentOngroundSales";
export const MAX_RECENT_ONGROUND_SALES = 5;

function readRaw() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return [];
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeRaw(list) {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {
    /* quota / private mode */
  }
}

/**
 * @returns {Array<{
 *   saleId: string,
 *   customerPk: number,
 *   partyPk: number,
 *   fullName: string,
 *   ticketLine: string,
 *   amountLabel: string,
 *   amountCents: number,
 *   paymentLabel: string,
 *   createdAt: string
 * }>}
 */
export function getRecentOngroundSales() {
  return readRaw().slice(0, MAX_RECENT_ONGROUND_SALES);
}

/**
 * @param {object} entry
 * @param {string} [entry.saleId]
 * @param {number} entry.customerPk
 * @param {number} entry.partyPk
 * @param {string} entry.fullName
 * @param {string} entry.ticketLine
 * @param {string} entry.amountLabel
 * @param {number} entry.amountCents
 * @param {string} entry.paymentLabel
 */
export function addRecentOngroundSale(entry) {
  if (!entry || entry.customerPk == null) {
    return readRaw().slice(0, MAX_RECENT_ONGROUND_SALES);
  }
  const row = {
    saleId: entry.saleId || `sale-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    customerPk: entry.customerPk,
    partyPk: entry.partyPk,
    fullName: entry.fullName || "Guest",
    ticketLine: entry.ticketLine || "—",
    amountLabel: entry.amountLabel || "0 EGP",
    amountCents: entry.amountCents != null ? entry.amountCents : 0,
    paymentLabel: entry.paymentLabel || "—",
    createdAt: entry.createdAt || new Date().toISOString(),
  };
  const next = [row, ...readRaw()].slice(0, MAX_RECENT_ONGROUND_SALES);
  writeRaw(next);
  return next;
}

export function clearRecentOngroundSales() {
  try {
    if (typeof window === "undefined" || !window.localStorage) return;
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
